import { render } from "./OverlineTitle.vue?vue&type=template&id=72a0cf1b"
import script from "./OverlineTitle.vue?vue&type=script&lang=js"
export * from "./OverlineTitle.vue?vue&type=script&lang=js"

import exportComponent from "/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__